var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from '../themes/styled';
import Box from '../box/Box';
import { ifProp, prop, theme } from 'styled-tools';
var MultiColumnText = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    @media ", " {\n        column-count: ", ";\n        column-gap: ", "px;\n        ", ";\n    }\n"], ["\n    @media ", " {\n        column-count: ", ";\n        column-gap: ", "px;\n        ", ";\n    }\n"])), theme('mediaQueries.sm'), prop('count'), function (p) { return theme("space.".concat(p.gap)); }, ifProp('width', css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                column-width: ", ";\n            "], ["\n                column-width: ", ";\n            "])), prop('width'))));
MultiColumnText.defaultProps = {
    count: 2,
    gap: 8,
};
export default MultiColumnText;
var templateObject_1, templateObject_2;
//# sourceMappingURL=MultiColumnText.js.map